import { Box } from '@mui/material'

import { ModalContent } from '@/components/Modal'

import { useConfigureController } from '../hooks/useController'

import { Footer } from './Footer'
import { Header } from './Header'
import { Body } from './Body/Body'

type Props = {
  driverIds: string[]
  validationResult?: uui.domain.server.rm.DeleteDriverValidationResults
}

export function Content(props: Props) {
  const { ready } = useConfigureController(props)

  if (!ready) return null

  return (
    <ModalContent header={<Header />} footer={<Footer />}>
      <Box paddingTop={2}>
        <Body />
      </Box>
    </ModalContent>
  )
}
